import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fromDate", "toDate", "output"]

  sync() {
    const from = this.fromDateTarget.value
    const to = this.toDateTarget.value

    if (from && to) {
      this.outputTarget.value = JSON.stringify([from, to])
    } else if (from) {
      this.outputTarget.value = from
    } else if (to) {
      this.outputTarget.value = to
    } else {
      this.outputTarget.value = ""
    }
  }
}
